import { Medias } from 'src/componentes/styles/breakpoints'

export const Mobile = `@media ${Medias.MOBILE}`
export const Tablet = `@media ${Medias.TABLET.MIN} and ${Medias.TABLET.MAX}`
export const Notebook = `@media ${Medias.NOTEBOOK.MIN} and ${Medias.NOTEBOOK.MAX}`
export const Desktop = `@media ${Medias.DESKTOP}`
export const PontoMaximoParaTablets = `@media ${Medias.TABLET.MAX}`
